import { render, staticRenderFns } from "./BlockList.vue?vue&type=template&id=74628720&scoped=true&"
import script from "./BlockList.vue?vue&type=script&lang=ts&"
export * from "./BlockList.vue?vue&type=script&lang=ts&"
import style0 from "./BlockList.vue?vue&type=style&index=0&id=74628720&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74628720",
  null
  
)

export default component.exports